import _styled from "@emotion/styled-base";
import React, { useContext } from 'react';
import { SiteConfigContext } from '@jelly/components';

var FooterContainer = _styled("footer", {
  target: "ekvoeiw0",
  label: "FooterContainer"
})("align-items:center;display:flex;background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.primary.main;
}, ";height:150px;justify-content:center;width:100%;*{max-width:150px;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9MaW5rQnVpbGRpbmcvRm9vdGVyLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJcUMiLCJmaWxlIjoiLi4vLi4vc3JjL0xpbmtCdWlsZGluZy9Gb290ZXIuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IHVzZUNvbnRleHQgfSBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgU2l0ZUNvbmZpZ0NvbnRleHQgfSBmcm9tICdAamVsbHkvY29tcG9uZW50cydcblxuY29uc3QgRm9vdGVyQ29udGFpbmVyID0gc3R5bGVkLmZvb3RlcmBcblx0YWxpZ24taXRlbXM6IGNlbnRlcjtcblx0ZGlzcGxheTogZmxleDtcblx0YmFja2dyb3VuZDogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5wYWxldHRlLnByaW1hcnkubWFpbn07XG5cdGhlaWdodDogMTUwcHg7XG5cdGp1c3RpZnktY29udGVudDogY2VudGVyO1xuXHR3aWR0aDogMTAwJTtcblx0KiB7XG5cdFx0bWF4LXdpZHRoOiAxNTBweDtcblx0fVxuYFxuXG4vKipcbiAqIEZvb3RlciB0aGF0IGp1c3QgY29uc2lzdHMgb2YgdGhlIHNpdGUgTG9nb1xuICovXG5leHBvcnQgZnVuY3Rpb24gRm9vdGVyKCkge1xuXHRjb25zdCB7XG5cdFx0c2l0ZUNvbXBvbmVudHM6IHsgU2l0ZUxvZ28gfSxcblx0fSA9IHVzZUNvbnRleHQoU2l0ZUNvbmZpZ0NvbnRleHQpXG5cblx0cmV0dXJuIChcblx0XHQ8Rm9vdGVyQ29udGFpbmVyIGlkPVwiZm9vdGVyXCI+XG5cdFx0XHQ8U2l0ZUxvZ28gY29sb3I9XCIjRkZGRkZGXCIgLz5cblx0XHQ8L0Zvb3RlckNvbnRhaW5lcj5cblx0KVxufVxuIl19 */"));
/**
 * Footer that just consists of the site Logo
 */


export function Footer() {
  var _useContext = useContext(SiteConfigContext),
      SiteLogo = _useContext.siteComponents.SiteLogo;

  return /*#__PURE__*/React.createElement(FooterContainer, {
    id: "footer"
  }, /*#__PURE__*/React.createElement(SiteLogo, {
    color: "#FFFFFF"
  }));
}